// this file is automatically generated by git.version.ts script
export const versions = {
  version: '0.17.12',
  revision: '84125726',
  branch: 'develop'
};